module.exports = __webpack_public_path__ + "static/media/banner-sm-g.0932271d.jpg";